'use strict';

// import 'whatwg-fetch';

import './lib/kit-module';
import './lib/register-module';
import './lib/modal-manager';
import './lib/addon-input';
import './lib/buttons';
import './lib/nav';
import './lib/modal';
// modules that are included on every page
import '../../_includes/modules/searchField/searchField';
import '../../_includes/modules/searchModal/searchModal';

import CompanyModal from '../../_includes/modules/searchAndFilter/companyModal';
import SearchAndFilter from '../../_includes/modules/searchAndFilter/searchAndFilter';

// register modules
const moduleClasses = {
  CompanyModal,
  SearchAndFilter,
};

// keep track of active modules
const modules = [];

/**
 * Initialize modules on elements with data-module="ModuleName"
 */
function initModules() {
  const $moduleElements = document.querySelectorAll('[data-module]');
  $moduleElements.forEach(($element) => {
    const id = $element.dataset.module;
    const ModuleClass = moduleClasses[id];
    if (!ModuleClass) return;

    const module = new ModuleClass($element);
    modules.push(module);
  });
}

initModules();
